// extracted by mini-css-extract-plugin
export default {"wrp":"Loader_wrp__LaL+v"};